import { render, staticRenderFns } from "./FormCascaderItem.vue?vue&type=template&id=33876b0c&"
import script from "./FormCascaderItem.vue?vue&type=script&lang=js&"
export * from "./FormCascaderItem.vue?vue&type=script&lang=js&"
import style0 from "./FormCascaderItem.vue?vue&type=style&index=0&id=33876b0c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports